import Modal from './Modal';
import { TerminalButton } from './TerminalButton';

interface ComingSoonDialogProps {
	isOpen: boolean;
	onClose: () => void;
}

export default function ComingSoonDialog(props: ComingSoonDialogProps) {
	return (
		<Modal isOpen={props.isOpen} onClose={props.onClose}>
			<div class="space-y-4" data-testid="coming-soon-dialog">
				<div class="space-y-2">
					<h2 class="text-lg font-bold text-green">Coming Soon</h2>
					<p class="text-green">
						This feature is currently under development and will be available in a future update.
					</p>
				</div>
				<div class="flex justify-end">
					<TerminalButton action={props.onClose} keyBinding="ENTER" text="OK" />
				</div>
			</div>
		</Modal>
	);
}
